var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-training-4301963",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.104,
    height: 45.102,
    viewBox: "0 0 45.104 45.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12826",
    "data-name": "Path 12826",
    d: "M166.017,62.2l0-.012V52.175a1.253,1.253,0,0,0-1.253-1.253h-42.6a1.253,1.253,0,0,0-1.253,1.253v42.6a1.253,1.253,0,0,0,1.253,1.253h42.6a1.253,1.253,0,0,0,1.253-1.253V62.212Zm-2.508-8.772v7.519H123.418V53.427ZM128.43,93.518V81.19a.9.9,0,0,1,.9-.9H139a.822.822,0,0,1,.416.117l.1.051a1.208,1.208,0,0,0,.131.073l.026.013-.006.013,5.838,4.961a1.251,1.251,0,0,0,1.627,0l6.129-5.251h0a.9.9,0,0,1,.646-.212.91.91,0,0,1,.619.318.872.872,0,0,1,.211.645.911.911,0,0,1-.314.618L146.9,88.078a.9.9,0,0,1-1.154,0l-3.771-3.22a1.253,1.253,0,0,0-2.066.953v7.7Zm13.982,0V88.531l1.71,1.46a3.482,3.482,0,0,0,4.417-.019l7.517-6.439,0,0h0a3.4,3.4,0,0,0,1.18-2.318,3.363,3.363,0,0,0-.809-2.48,3.4,3.4,0,0,0-2.318-1.18,3.343,3.343,0,0,0-2.479.808l-5.315,4.555L141.3,78.647h0a3,3,0,0,0-.453-.323l-.012-.006a1.463,1.463,0,0,0-.189-.1A3.329,3.329,0,0,0,139,77.782h-9.672a3.411,3.411,0,0,0-3.408,3.407V93.518h-2.506V63.452h40.091V93.518Z",
    transform: "translate(-120.913 -50.922)",
    fill: "#5c2d82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12827",
    "data-name": "Path 12827",
    d: "M174.342,103.106a1.253,1.253,0,1,1-1.253-1.253,1.253,1.253,0,0,1,1.253,1.253",
    transform: "translate(-166.823 -96.839)",
    fill: "#5c2d82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12828",
    "data-name": "Path 12828",
    d: "M225.252,103.106A1.253,1.253,0,1,1,224,101.853a1.253,1.253,0,0,1,1.253,1.253",
    transform: "translate(-212.721 -96.839)",
    fill: "#5c2d82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12829",
    "data-name": "Path 12829",
    d: "M276.162,103.106a1.253,1.253,0,1,1-1.253-1.253,1.253,1.253,0,0,1,1.253,1.253",
    transform: "translate(-258.619 -96.839)",
    fill: "#5c2d82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12830",
    "data-name": "Path 12830",
    d: "M389.411,104.353h11.276a1.253,1.253,0,1,0,0-2.506H389.411a1.253,1.253,0,1,0,0,2.506Z",
    transform: "translate(-361.846 -96.834)",
    fill: "#5c2d82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12831",
    "data-name": "Path 12831",
    d: "M207.6,203.659a5.242,5.242,0,1,0,3.7,1.535,5.234,5.234,0,0,0-3.7-1.535Zm0,7.965a2.733,2.733,0,1,1,1.929-.8,2.73,2.73,0,0,1-1.929.8Z",
    transform: "translate(-194.345 -188.623)",
    fill: "#5c2d82"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training_icon.ee066688ebd9aee094694facfd5679d9.svg";
export { ForwardRef as ReactComponent };